<template>
  <section class="relative z-20 bg-gradient-to-b from-secondary-light via-secondary-light to-secondary-dark">
    <slot></slot>
  </section>
</template>
